/**
 * Shared date preset range utility.
 * Used by ExpenseDashboardPage, ExpenseAggregationsPage, and ExpenseList.
 */
import { todayInTimezone } from '@resida/shared';

export function getDatePresetRange(preset: string, timezone: string): { start: string; end: string } {
  const todayStr = todayInTimezone(timezone);
  const parts = todayStr.split('-').map(Number);
  const year = parts[0]!;
  const end = todayStr;
  const subtractDays = (days: number): string => {
    const d = new Date(parts[0]!, parts[1]! - 1, parts[2]!);
    d.setDate(d.getDate() - days);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };
  switch (preset) {
    case 'last30': return { start: subtractDays(30), end };
    case 'last60': return { start: subtractDays(60), end };
    case 'last90': return { start: subtractDays(90), end };
    case 'ytd': return { start: `${year}-01-01`, end };
    case 'lastYear': return { start: `${year - 1}-01-01`, end: `${year - 1}-12-31` };
    default: return { start: '', end: '' };
  }
}
